<template>
  <div :id="`message-thread-${id}`" class="message-thread embedly">
    <thread-original-message-or-deleted :thread-id="id" :title="title" :original-message="originalMessage" />
    <ul class="message-thread-replies">
      <thread-reply-or-deleted v-for="reply in replies" :key="reply.id" class="message" :thread-id="id" :reply="reply" />
      <reply-create-control :thread-id="id" />
    </ul>
  </div>
</template>

<script>
import ThreadOriginalMessageOrDeleted from './thread-original-message-or-deleted'
import ThreadReplyOrDeleted from './thread-reply-or-deleted'
import ReplyCreateControl from './reply-create-control'

export default {
  components: { ThreadReplyOrDeleted, ThreadOriginalMessageOrDeleted, ReplyCreateControl },

  props: {
    id: {
      type: Number,
      required: true
    },
    originalMessage: {
      type: Object,
      required: true
    },
    replies: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
  @use "~common_styles/breakpoints" as breakpoints;

  .message-thread {
    margin-bottom: 10px;
  }

  .message-thread-replies {
    list-style: none;
    padding-inline-start: 110px;
  }

  @include breakpoints.screen-mobile-only {
    .message-thread-replies {
      padding-inline-start: unset;
    }
  }
</style>
